import React, { forwardRef, ChangeEvent, ReactNode } from 'react';
import styles from './input_text.module.scss';

type Props = {
  className?: string;
  maxLength?: number;
  placeholder?: string;
  onChange: (event: ChangeEvent<HTMLInputElement>) => void;
  id: string;
  value?: string;
  children?: ReactNode;
  name?: string;
  size?: number;
};

export const InputText = forwardRef<HTMLInputElement, Props>(
  (
    {
      className = '',
      maxLength = 524288,
      placeholder = '',
      onChange,
      id,
      value,
      children,
      name,
      size = 20,
    },
    ref,
  ) => (
    <label className={styles.label} htmlFor={id}>
      {children}
      <input
        name={name}
        ref={ref}
        className={`${styles.input} ${className}`}
        type="text"
        size={size}
        placeholder={placeholder}
        maxLength={maxLength}
        spellCheck={false}
        id={id}
        onChange={onChange}
        value={value}
      />
    </label>
  ),
);
